import {
  AiRedoIcon,
  IconButton,
  IconButtonColorEnum,
  IconButtonSizeEnum,
  IconSizeEnum,
  Tooltip,
} from '@acceso/design-system';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';

import { RelaunchEnrichmentsModal } from '@/components/RelaunchEnrichmentsModal/RelaunchEnrichmentsModal';
import { ReviewStateField } from '@/components/ReviewStateField/ReviewStateField';
import { useBroadcastScheduleProgram } from '@/features/broadcast-schedule-program/context/BroadcastScheduleProgramContext';
import { usePostSegmentsBatch } from '@/features/segments/api/post-segments-batch';
import { useDisclosureWithData } from '@/hooks/useDisclosureWithData';
import { useSelectedItemsStore } from '@/stores/selected-items';

export function BroadcastScheduleProgramBodySegmentCardBulkActions() {
  const store = useSelectedItemsStore();
  const relaunchDialog = useDisclosureWithData();
  const { mutate: processSegmentsBatch, isPending: isProcessingSegments } = usePostSegmentsBatch({
    config: {
      onSuccess: () => {
        store.dispatch({ type: 'resetIds' });
      },
    },
  });
  const { t } = useTranslation();
  const hasSelection = store.include.length > 0;
  const { segmentItems } = useBroadcastScheduleProgram();
  const hasRadioSelected =
    segmentItems?.some(item => store.include.includes(item.id) && item.media_type === 'rts') ||
    false;

  return (
    <div className="flex gap-2">
      <Tooltip help={t('Cambiar estado')} grow>
        <ReviewStateField
          disabled={!hasSelection || isProcessingSegments}
          onChange={value => {
            processSegmentsBatch({
              action: 'update',
              items: store.include.map(id => ({
                id,
                review_state: value,
              })),
            });
          }}
        />
      </Tooltip>

      <Tooltip help={t('Relanzar')} grow>
        <IconButton
          onClick={() => {
            relaunchDialog.open();
          }}
          size={IconButtonSizeEnum.XS}
          color={IconButtonColorEnum.NONE_DEFAULT}
          disabled={isProcessingSegments}
        >
          <AiRedoIcon disabled={store.include.length === 0} size={IconSizeEnum.SM} />
        </IconButton>
      </Tooltip>

      {/* Use react portal to render modal over toolkit and calendar */}
      {createPortal(
        <RelaunchEnrichmentsModal
          isOpen={relaunchDialog.isOpen}
          onClose={relaunchDialog.close}
          onAction={enrichments => {
            processSegmentsBatch({
              action: 'relaunch',
              items: store.include.map(id => ({ id })),
              enrichments,
            });
          }}
          heading={t('Relanzar procesos de enriquecimiento')}
          actionLabel={t('Lanzar procesos')}
          isRadio={hasRadioSelected}
        />,
        document.body
      )}
    </div>
  );
}
